import json from "@/data/copy/blog-page.json";
import { createCopyGetter } from "./localize-copy";

export const getBlogPageCopy = /*#__PURE__*/ createCopyGetter(json);
